/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-08-15 11:20:56
 */

import { ProFormSwitch, ProFormText, ProTable, ProColumns, ProFormSelect, DragSortTable } from "@ant-design/pro-components";
import { useEffect, useState, useRef } from "react";
import { InfoCircleOutlined, InfoOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { message, Modal, Space, Popover, Button, Tag, Divider, Table, Switch, Spin } from "antd";
import { useNavigate } from "react-router-dom";

import { fetchAdvBindingList, fetchToggleAdvBinding } from "@/api/modules/AdAccount";

import "../index.less";
const AutomatedRulesModal: React.FC<{
	open: boolean;
	currentAccount: any;
	onClose: () => void;
}> = ({ open, currentAccount, onClose }) => {
	const { t } = useTranslation();

	const actionRef = useRef();

	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (!open) {
			return;
		}
	}, [open]);

	const handleBinding = (rule, action) => {
		setLoading(true);
		fetchToggleAdvBinding({
			action: action,
			advId: currentAccount.advId,
			strategyId: rule.strategyId
		}).then(res => {
			if (res.code === 200) {
				message.success(t("message.success"));
			} else {
				message.error(res.message);
			}
			setLoading(false);
		});
	};

	const columns: ProColumns<any>[] = [
		{
			title: t("automatedRules.account.bingding.strtegy.binging.state"),
			width: 200,
			render: (_, record) => {
				if (record.isBinding) {
					return <Switch defaultValue={true} onChange={() => handleBinding(record, "UNBINDING")} />;
				} else {
					return <Switch defaultValue={false} onChange={() => handleBinding(record, "BINDING")} />;
				}
			}
		},
		{
			title: t("automatedRules.actionHistory.table.column2"),
			key: "strategyName",
			dataIndex: "strategyName",

			width: "60%"
		},
		{
			title: t("automatedRules.account.bingding.strtegy.binging.enable.state"),
			key: "operation",
			align: "center",
			width: 200,
			render: (_, record) => {
				if (record.isEnable) {
					return <Tag color="success">开启</Tag>;
				} else {
					return <Tag color="error">关闭</Tag>;
				}
			}
		}
	];

	return (
		<Modal
			title="规则列表"
			closable
			onCancel={onClose}
			footer={
				<Button onClick={onClose} className="closeButton">
					{t("action.button.close")}
				</Button>
			}
			open={open}
			width={1000}
			height={800}
			className="rules-containers"
			destroyOnClose
		>
			<div className="ruleContent">
				<div className="ruleInfo" style={{ marginTop: "20px", marginBottom: 20 }}>
					<span>
						<InfoOutlined style={{ borderRadius: "50%", background: "#FFAF41", color: "#fff", marginRight: 5 }} />
						{t("automatedRules.account.bingding.strtegy.binging.tip")}
					</span>
				</div>
				<ProTable
					actionRef={actionRef}
					columns={columns}
					rowKey="strategyId"
					request={async ({ params, filter, sort }) => {
						let res = await fetchAdvBindingList({
							advId: currentAccount.advId,
							...params,
							...filter,
							...sort
						});
						return {
							data: res?.data?.list,
							total: res?.data?.total,
							success: true
						};
					}}
					search={false}
					options={false}
				/>
			</div>
		</Modal>
	);
};

export default AutomatedRulesModal;
